import { FetchContext } from '../fetch-context';
import { WinnerContact } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getWinnerOrganization: (
  fetchContext: FetchContext,
  winnerId: number,
  accessToken?: string,
) => Promise<WinnerContact> = (fetchContext, winnerId, accessToken) => fetch(`${fetchContext.baseUrl}/api/winners/${winnerId}/organization`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<WinnerContact>(fetchContext.errorStore, response, 'get winner organization'));
